import { Android24 } from 'ui/icons/devices/Android24';
import { Apple24 } from 'ui/icons/devices/Apple24';

export const VIEW_OPTIONS = [
  { name: <Apple24 />, key: 'apple', value: 'apple' },
  { name: <Android24 />, key: 'android', value: 'android' },
];
